export const cardReaderTypes = {
    loading: "LOADING_CARDREADER",
    delete: "DELETE_CARDREADER",
    loadedOne: "LOADED_CARDREADER",
    loadedMultiple: "LOADED_CARDREADERS",
    success: "SUCCESS_CARDREADER",
    restore: "RESTORE_CARDREADER",
    hardDelete: "HARDDELETE_CARDREADER",
};
